import { deleteRequest, get, publicPost, put } from "../../helpers/apihelpers";

export const CreateFileStandardService=async(data)=>{
    try {
        const result = await publicPost(`api/admin/filestandard/create`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const UpdateFileStandardService=async(data,id)=>{
    try {
        const result = await put(`api/admin/filestandard/update/${id}`, data);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const GetFileStandardService=async()=>{
    try {
        const result = await get(`api/admin/filestandard/get`);
        return result;
    } catch (err) {
        return err.response;
    }
}

export const DeleteFileStandardService=async(id)=>{
    try {
        const result = await deleteRequest(`api/admin/filestandard/delete/${id}`);
        return result;
    } catch (err) {
        return err.response;
    }
}

